import React from "react";
import dashboardCardIcon from "assets/market_Pluse_dashboard.svg";
import CONSTANTS from "constants/constants";

const { MARKET_PULSE } = CONSTANTS;

const DashboardCard = () => (
  <div className="dashboard-card-row pt2">
    <div className="dashboard-card-graphic">
      {/* <div className="dashboard-card-graphic-image" /> */}
      <img src={dashboardCardIcon} alt="Dashboard Card" />
    </div>
    <div className="dashboard-card-content">
      <h3 className="dashboard-card-title">
        <span className="dashboard-card-title-highlight">{MARKET_PULSE.DASHBOARD_TITLE_HIGHLIGHT}</span> {MARKET_PULSE.DASHBOARD_TITLE}
      </h3>
      <ul className="dashboard-card-list">
        <li>
          <span className="dashboard-card-dot" />
          <span className="dashboard-card-list-title">{MARKET_PULSE.DASHBOARD_LIST_1_TITLE}</span>
        </li>
        <li>
          <div className="dashboard-card-list-desc">{MARKET_PULSE.DASHBOARD_LIST_1_DESC}</div>
        </li>
        <li>
          <span className="dashboard-card-dot" />
          <span className="dashboard-card-list-title">{MARKET_PULSE.DASHBOARD_LIST_2_TITLE}</span>
        </li>
        <li>
          <div className="dashboard-card-list-desc">{MARKET_PULSE.DASHBOARD_LIST_2_DESC}</div>
        </li>
      </ul>
    </div>
  </div>
);

export default DashboardCard; 